<template>
    <div class="card">
        <div
            class="card-header content-center text-white p-0"
            :class="[`bg-${color}`, addHeaderClasses]"
        >
            <slot />
        </div>
        <slot name="body">
            <div class="card-body align-items-center row text-center">
                <div class="col">
                    <div
                        v-if="rightHeader"
                        class="fs-5 fw-semibold"
                    >
                        {{ rightHeader }}
                    </div>
                    <div
                        v-if="rightFooter"
                        class="text-uppercase text-muted small"
                    >
                        {{ rightFooter }}
                    </div>
                </div>
                <div class="vr" />
                <div class="col">
                    <div
                        v-if="leftHeader"
                        class="fs-5 fw-semibold"
                    >
                        {{ leftHeader }}
                    </div>
                    <div
                        v-if="leftFooter"
                        class="text-uppercase text-muted small"
                    >
                        {{ leftFooter }}
                    </div>
                </div>
            </div>
        </slot>
    </div>
</template>

<script>
export default {
    name: 'DWidgetBrand',
    props: {
        color: {
            type: String,
            default: null
        },
        rightHeader: {
            type: String,
            default: null
        },
        rightFooter: {
            type: String,
            default: null
        },
        leftHeader: {
            type: String,
            default: null
        },
        leftFooter: {
            type: String,
            default: null
        },
        addHeaderClasses: {
            type: [String, Array, Object],
            default: null
        }
    }
}
</script>

<style>
.content-center {
    align-items: center;
    display: flex;
    justify-content: center;
    padding: 0;
    position: relative;
    text-align: center;
}
</style>
